export const invalidateInsuranceOffers = (client, documentId, exclude = []) => {
  const cacheKeys = Object.keys(client.cache.data.data).filter(
    x => x.startsWith(`QuotationData:{"documentId":${documentId}`) && !exclude.includes(x)
  );
  cacheKeys.forEach(key => client.cache.evict({ id: key }));
  client.cache.gc();
};
